import AuthNavbar from './AuthNavbar';

export default AuthNavbar;
